import { yupResolver } from '@hookform/resolvers/yup';
import React, { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { View } from 'react-native';
import { Footer, Input, Text } from '~/components';

import * as yup from 'yup';
import { isCpf } from '~/utils/yup';
import { useCreateAccountForm } from '~/stores';
import type { CreateAccuntStepsProps } from '../..';

interface StepFormData {
  document: string;
}

export const schema = yup
  .object()
  .shape({
    document: isCpf(),
  })
  .required();

const DocumentPage: React.FC<CreateAccuntStepsProps> = ({ onContinue }) => {
  const { setDocument } = useCreateAccountForm();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<StepFormData>({
    resolver: yupResolver(schema),
  });

  const onSubmit = useCallback(
    ({ document }: StepFormData) => {
      setDocument(document);
      onContinue?.();
    },
    [onContinue, setDocument]
  );

  return (
    <View className="justify-between lg:w-[450px]">
      <Text className="text-[22px] text-center text-gray-700 mt-6 mb-14">
        Ok! Informe seu{' '}
        <Text className="text-primary-600 font-medium">CPF</Text>
      </Text>

      <View className="mb-10">
        <Input
          control={control}
          name="document"
          label="CPF"
          placeholder="CPF"
          keyboardType="number-pad"
          error={errors.document?.message}
          maskConfig={{ type: 'cpf' }}
        />
      </View>

      <Footer
        noPadding
        onSubmit={handleSubmit(onSubmit)}
        buttonLabel="Próximo"
      />
    </View>
  );
};

export default DocumentPage;
